import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import {
  themes,
  brightColorTimePicker,
  defaultAllSelection,
} from "services/constants";
import { showToast } from "services/utils/Status";
import dayjs from "dayjs";
import sessionHandling from "services/utils/notificationUtils";
import { customGetAPI } from "services/utils/CustomAPI";
import { DatePicker } from "@mui/x-date-pickers";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  AddCircleOutline,
  Close,
  ArrowUpward,
  ArrowDownward,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { entryMethod } from "pages/TeamZone/TeamZoneHeaders";
import ShiftDetailsRow from "../ShiftDetailsRow";
import { tooltipStyleProps } from "services/constants/Styles";
export const PunchDetails = ({
  shiftDetails,
  attendanceDetails,
  setUpdatePunchEntry,
  updatePunchEntry,
  departmentId,
  setGetEntryDetails,
  setAttendanceDetails,
  overallData,
  setGetUpdatedData,
  reCallApi,
}) => {
  const { domain, token } = useSelector((state) => state.tokenReducer);

  const [entriesDetails, setEntries] = useState([]);
  const [count, setCount] = useState(1);
  const [checked, setChecked] = useState(attendanceDetails.early_exit);
  const [newShiftDetails, setNewShiftDetails] = useState({
    shiftName: shiftDetails?.shift_name,
    shiftid: shiftDetails?.shift_id,
  });
  const [departmentShiftDetails, setDepartmentShiftDetails] = useState([]);
  const [getDepartmentShifts, setGetDepartmentShifts] = useState(true);
  let countLength =
    entriesDetails.length !== 0
      ? Math.max(...entriesDetails.map((entry) => entry.rowId))
      : 0;

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      const url =
        departmentId !== defaultAllSelection
          ? `${domain}deparment-shift-filter/?department_id=${departmentId}&date=${attendanceDetails?.date
              .split("-")
              .reverse()
              .join("-")}`
          : `${domain}all/shift-filter/`;
      const res = await customGetAPI(url);
      if (res.ok) {
        setDepartmentShiftDetails(
          res?.responseDetails.filter((data) => {
            return data?.shift_name !== "Weekoff";
          })
        );
      } else {
        setDepartmentShiftDetails([]);
      }
    };
    if (getDepartmentShifts) {
      fetchIndividualUserDetails();
      setGetDepartmentShifts(false);
    }
  }, [
    attendanceDetails?.date,
    departmentId,
    domain,
    getDepartmentShifts,
    shiftDetails.date,
    shiftDetails.shift_filter_date,
  ]);

  useEffect(() => {
    const updatePunchDetails = () => {
      if (attendanceDetails?.length !== 0) {
        let updatedData = attendanceDetails?.punch_entries?.map((data) => ({
          ...data,
          rowId: data.rowId ? data.rowId : data.punch_id,
        }));
        setEntries(updatedData);
        setChecked(attendanceDetails.early_exit);
        setCount(updatedData.length + 1);
      }
    };
    if (updatePunchEntry) {
      updatePunchDetails();
      setUpdatePunchEntry(false);
    }
  }, [
    attendanceDetails.early_exit,
    attendanceDetails?.length,
    attendanceDetails.make_as_absent,
    attendanceDetails?.punch_entries,
    attendanceDetails?.weekoff_pay,
    setUpdatePunchEntry,
    updatePunchEntry,
  ]);

  const handleEntryLogin = (id, value) => {
    let updatedTime = entriesDetails.map((data) =>
      data.rowId === id
        ? { ...data, direction: value ? value.label : null }
        : data
    );
    setEntries(updatedTime);
    updtaeGlobalInOUTEntries(id, value);
  };

  const updtaeGlobalInOUTEntries = (id, value) => {
    const updatedOverallData = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        const updatedPunchEntries = (attendance_map?.punch_entries || []).map(
          (entry) =>
            entry.rowId === id
              ? {
                  ...entry,
                  direction: value ? value.label : null,
                }
              : entry
        );
        return {
          ...attendance_map,
          punch_entries: updatedPunchEntries,
        };
      }
      return attendance_map;
    });
    setAttendanceDetails(updatedOverallData);
  };

  const addNewCheckInOutEntries = () => {
    if (validateFieldValues()) {
      let lastEntryDirection =
        entriesDetails.length > 0
          ? entriesDetails[entriesDetails.length - 1].direction
          : "OUT";
      let newEntry = {
        rowId: countLength + 1,
        date: attendanceDetails?.date,
        time: null,
        direction: lastEntryDirection === "OUT" ? "IN" : "OUT",
      };
      setEntries([...entriesDetails, newEntry]);
      countLength = countLength + 1;
      const updatedOverallData = overallData.map((attendance_map) => {
        if (attendance_map.id === attendanceDetails.id) {
          return {
            ...attendance_map,
            punch_entries: [...(attendance_map?.punch_entries || []), newEntry],
            error: "",
          };
        }
        return attendance_map;
      });

      setAttendanceDetails(updatedOverallData);
      setCount(count + 1);
    }
  };

  const updateTimeConfigurations = (newTime, id) => {
    let updatedTime = entriesDetails.map((data) =>
      data.rowId === id
        ? { ...data, time: dayjs(newTime).format("HH:mm") }
        : data
    );
    updateGlobalData(newTime, id);
    setEntries(updatedTime);
  };

  const updateGlobalData = (newTime, id) => {
    const updatedOverallData = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        const updatedPunchEntries = (attendance_map?.punch_entries || []).map(
          (entry) =>
            entry.rowId === id
              ? {
                  ...entry,
                  time: newTime ? dayjs(newTime).format("HH:mm") : null,
                }
              : entry
        );
        return {
          ...attendance_map,
          punch_entries: updatedPunchEntries,
        };
      }
      return attendance_map;
    });
    setAttendanceDetails(updatedOverallData);
  };

  const removeCheckInOutEntryRow = (rowData) => {
    const overAllAttendanceDetails = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        const updatedPunchEntries = (
          attendance_map?.punch_entries || []
        ).filter((entry) => entry.rowId !== rowData.rowId);
        return {
          ...attendance_map,
          punch_entries: updatedPunchEntries,
          early_exit:
            updatedPunchEntries.length === 0
              ? false
              : attendance_map.early_exit,
        };
      }
      return attendance_map;
    });

    setAttendanceDetails(overAllAttendanceDetails);
    setUpdatePunchEntry(true);
  };

  const arrowUpward = (rowData) => {
    const previousRowDateCheck = overallData.find(
      (item) => item.id === attendanceDetails.id - 1
    );
    const parseDMY = (dateStr) => {
      const [day, month, year] = dateStr.split("-");
      return new Date(year, month - 1, day);
    };

    const currentDate = parseDMY(rowData.date);
    const prevDate = parseDMY(previousRowDateCheck.date);
    const diffInDays = (currentDate - prevDate) / (1000 * 60 * 60 * 24);

    if (!(diffInDays === 0 || diffInDays === 1)) {
      showToast("error", "Cannot move entry. Dates do not match.");
      return;
    }

    let overAllAttendanceDetails = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        return {
          ...attendance_map,
          punch_entries: (attendance_map?.punch_entries || []).filter(
            (entry) => entry.punch_id !== rowData.punch_id
          ),
        };
      }
      if (attendance_map.id === attendanceDetails.id - 1) {
        return {
          ...attendance_map,
          punch_entries: [...(attendance_map?.punch_entries || []), rowData],
        };
      } else {
        return attendance_map;
      }
    });
    setAttendanceDetails(overAllAttendanceDetails);
    setUpdatePunchEntry(true);
  };

  const arrowDownWard = (rowData) => {
    const nextRowDateCheck = overallData.find(
      (item) => item.id === attendanceDetails.id + 1
    );
    if (rowData.date !== nextRowDateCheck.date) {
      showToast("error", "Cannot move entry. Dates do not match.");
      return;
    }
    let overAllAttendanceDetails = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        return {
          ...attendance_map,
          punch_entries: (attendance_map?.punch_entries || []).filter(
            (entry) => entry.punch_id !== rowData.punch_id
          ),
        };
      }
      if (attendance_map.id === attendanceDetails.id + 1) {
        return {
          ...attendance_map,
          punch_entries: [rowData, ...(attendance_map?.punch_entries || [])],
        };
      } else {
        return attendance_map;
      }
    });
    setAttendanceDetails(overAllAttendanceDetails);
    setUpdatePunchEntry(true);
  };

  const updateEntryDate = (newValue, id) => {
    let formatedData = dayjs(newValue).format("DD-MM-YYYY");
    let updatedTime = entriesDetails.map((data) =>
      data.rowId === id ? { ...data, date: formatedData } : data
    );
    setEntries(updatedTime);
    updateGlobalEntryData(newValue, id);
  };

  const updateGlobalEntryData = (newValue, id) => {
    const updatedOverallData = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        let formatedData = dayjs(newValue).format("YYYY-MM-DD");
        const updatedPunchEntries = (attendance_map?.punch_entries || []).map(
          (entry) =>
            entry.rowId === id
              ? {
                  ...entry,
                  date: formatedData,
                }
              : entry
        );
        return {
          ...attendance_map,
          punch_entries: updatedPunchEntries,
        };
      }
      return attendance_map;
    });
    setAttendanceDetails(updatedOverallData);
  };

  const validateFieldValues = () => {
    const findNullValue = entriesDetails.filter(
      (entry) =>
        !entry.date ||
        !entry.direction ||
        !entry.date ||
        entry.date === "Invalid Date" ||
        entry.time === "Invalid Date" ||
        !entry.time
    );
    if (findNullValue.length <= 0) {
      return true;
    } else {
      let overalldataupdated = overallData.map((attendance_map) => {
        if (attendance_map.id === attendanceDetails.id) {
          return {
            ...attendance_map,
            error: "Value is required",
          };
        }
        return attendance_map;
      });
      setAttendanceDetails(overalldataupdated);
      return false;
    }
  };

  const handleChange = (e, attendanceDetails) => {
    let overalldataupdated = overallData.map((attendance_map) => {
      if (attendance_map.id === attendanceDetails.id) {
        return {
          ...attendance_map,
          early_exit: e.target.checked,
        };
      }
      return attendance_map;
    });
    setAttendanceDetails(overalldataupdated);
    setChecked(e.target.checked);
  };

  const handleShiftName = (data) => {
    if (data) {
      setNewShiftDetails({
        shiftName: data?.shift_name,
        shiftid: data?.shift_id,
      });
    }
  };

  const updateShiftBasedOnRange = async () => {
    try {
      const response = await fetch(`${domain}shift_assignments/daily/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          shift_assignments: [
            {
              user: shiftDetails?.user_id,
              daily_assignments: [
                {
                  shift_id: newShiftDetails?.shiftid,
                  date: attendanceDetails?.date.split("-").reverse().join("-"),
                  is_week_off: newShiftDetails?.shiftName === "Weekoff",
                },
              ],
            },
          ],
        }),
      });
      const res = await response.json();
      if (response.ok) {
        showToast("success", "Shift changed successfully");
        setAttendanceDetails([]);
        setGetEntryDetails(true);
        setGetUpdatedData(true);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };

  return (
    <>
      <React.Fragment>
        <Mui.Grid
          container
          sx={{
            paddingLeft: 2,
            paddingRight: 2,
            paddingTop: 0.5,
            paddingBottom: 2,
          }}
        >
          <Mui.Grid
            container
            sx={{
              border: `2px solid ${themes.sidebarDivider}`,
              borderRadius: "10px 10px 10px 10px",
              backgroundColor: themes.whiteColor,
            }}
          >
            <Mui.Grid container>
              <ShiftDetailsRow
                attendanceDetails={attendanceDetails}
                departmentShiftDetails={departmentShiftDetails}
                handleShiftName={handleShiftName}
                updateShiftBasedOnRange={updateShiftBasedOnRange}
                themes={themes}
                showAutoComplete={true}
              />
            </Mui.Grid>
            <Mui.Grid
              container
              sx={{
                borderBottom: `2px solid ${themes.sidebarDivider}`,
              }}
            ></Mui.Grid>

            {entriesDetails?.map((data, index) => (
              <Mui.Grid container>
                <Mui.Grid
                  xs={12}
                  sm={12}
                  md={4}
                  lg={entriesDetails?.length === 1 ? 3.5 : 4}
                  xl={entriesDetails?.length === 1 ? 3.5 : 4}
                  sx={{ padding: 1 }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <div sx={{ width: 4 }}>
                        <DatePicker
                          size="small"
                          slotProps={{
                            textField: {
                              size: "small",
                              inputProps: {
                                readOnly: true,
                                onKeyDown: (e) => {
                                  if (
                                    e.key === "ArrowUp" ||
                                    e.key === "ArrowDown"
                                  ) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }
                                },
                              },
                            },
                          }}
                          sx={{ minWidth: "80%" }}
                          value={dayjs(data?.date, "DD/MM/YYYY")}
                          minDate={dayjs(attendanceDetails?.date, "DD/MM/YYYY")}
                          maxDate={
                            dayjs(attendanceDetails?.date, "DD/MM/YYYY").isSame(
                              dayjs(),
                              "day"
                            )
                              ? dayjs()
                              : dayjs(
                                  attendanceDetails?.date,
                                  "DD/MM/YYYY"
                                ).add(1, "day")
                          }
                          onChange={(newValue) => {
                            updateEntryDate(newValue, data.rowId);
                          }}
                          format="DD/MM/YYYY"
                        />
                      </div>
                    </DemoContainer>
                  </LocalizationProvider>
                  {(data?.date === "Invalid Date" || !data?.date) &&
                  attendanceDetails?.error === "Value is required" ? (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1, paddingTop: 0.5 }}
                    >
                      Date is required
                    </Mui.Typography>
                  ) : null}
                </Mui.Grid>
                <Mui.Grid
                  xs={12}
                  sm={12}
                  md={4}
                  lg={3.5}
                  xl={3.5}
                  sx={{ padding: 1 }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <div sx={{ width: 4 }}>
                        <TimePicker
                          ampm={false}
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          value={data?.time ? dayjs(data.time, "HH:mm") : null}
                          slotProps={brightColorTimePicker}
                          onChange={(newValue) => {
                            updateTimeConfigurations(newValue, data.rowId);
                          }}
                        />
                      </div>
                    </DemoContainer>
                  </LocalizationProvider>
                  {(data?.time === "Invalid Date" || !data?.time) &&
                  attendanceDetails?.error === "Value is required" ? (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1, paddingTop: 0.5 }}
                    >
                      Time is required
                    </Mui.Typography>
                  ) : null}
                </Mui.Grid>
                <Mui.Grid
                  xs={10}
                  sm={10}
                  md={3}
                  lg={2.5}
                  xl={2.5}
                  sx={{ paddingTop: { xs: 1, sm: 1, md: 2 } }}
                >
                  <Mui.Autocomplete
                    id="combo-box-demo"
                    size="small"
                    value={data?.direction}
                    options={entryMethod}
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option.label
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    renderOption={(props, option) => {
                      return <li {...props}>{option.label}</li>;
                    }}
                    onChange={(event, value) => {
                      handleEntryLogin(data?.rowId, value);
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <Mui.TextField
                        {...params}
                        value={data?.direction}
                        sx={{ background: themes.whiteColor }}
                        placeholder={"Select entry type"}
                        size="small"
                      />
                    )}
                  />
                  {!data?.direction &&
                  attendanceDetails?.error === "Value is required" ? (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1, paddingTop: 0.5 }}
                    >
                      Direction is required
                    </Mui.Typography>
                  ) : null}
                </Mui.Grid>
                <Mui.Grid
                  xs={2}
                  sm={2}
                  md={1}
                  lg={entriesDetails?.length === 1 ? 2.5 : 2}
                  xl={entriesDetails?.length === 1 ? 2.5 : 2}
                  sx={{ paddingTop: { xs: 1, sm: 1, md: 2 } }}
                >
                  <Mui.IconButton
                    onClick={() => {
                      removeCheckInOutEntryRow(data);
                    }}
                  >
                    <Close />
                  </Mui.IconButton>
                  {attendanceDetails?.id === 1 ||
                    (index === 0 && (
                      <Mui.IconButton
                        onClick={() => {
                          arrowUpward(data);
                        }}
                      >
                        <ArrowUpward />
                      </Mui.IconButton>
                    ))}
                  {overallData?.length === attendanceDetails?.id ||
                    (index === entriesDetails?.length - 1 && (
                      <Mui.IconButton
                        onClick={() => {
                          arrowDownWard(data);
                        }}
                      >
                        <ArrowDownward />
                      </Mui.IconButton>
                    ))}
                </Mui.Grid>
              </Mui.Grid>
            ))}

            <Mui.Grid container sx={{ padding: 1 }}>
              <Mui.IconButton
                onClick={() => {
                  addNewCheckInOutEntries();
                }}
              >
                <AddCircleOutline />
              </Mui.IconButton>
            </Mui.Grid>
            <Mui.Grid
              container
              sx={{
                borderBottom: `2px solid ${themes.sidebarDivider}`,
              }}
            ></Mui.Grid>
            <Mui.Grid
              container
              sx={{ padding: 1, paddingLeft: 1 }}
              alignItems="center"
            >
              <Mui.Grid item xs={0.5}>
                <Mui.Checkbox
                  checked={checked}
                  onChange={(e) => handleChange(e, attendanceDetails)}
                  inputProps={{ "aria-label": "controlled" }}
                  disabled={attendanceDetails?.punch_entries.length === 0}
                />
              </Mui.Grid>

              <Mui.Grid item xs={0.3}></Mui.Grid>

              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                title="If the Early Exit flag is clicked, the break entries go to check-out, and the check-in without check-out entries go missing."
              >
                <Mui.Grid item>
                  <Mui.Typography
                    sx={{
                      fontSize: 16,
                      color: themes.headLine,
                      fontWeight: 600,
                    }}
                  >
                    Early Exit
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Tooltip>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </React.Fragment>
    </>
  );
};
